const PRODUCTS = [
  // --- OTC (first category) — at least 4 products ---
  {
    id: "prod_aspirin_bayer",
    title: "Bayer Aspirin 325mg Tablets",
    brand: "Bayer",
    rating: { avg: 4.7, count: 214 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/593451/pexels-photo-593451.jpeg?cs=srgb&dl=pexels-julie-viken-148496-593451.jpg&fm=jpg",
      "https://images.pexels.com/photos/3683041/pexels-photo-3683041.jpeg?cs=srgb&dl=pexels-shvetsa-3683041.jpg&fm=jpg"
    ],
    variants: [
      { id: "v24", label: "24 tablets", price: 5.49, mrp: 6.99, stock: 45 },
      { id: "v100", label: "100 tablets", price: 14.99, mrp: 18.99, stock: 28 }
    ],
    active_ingredients: [
      { name: "Aspirin", amount: 325, unit: "mg" }
    ],
    directions: "Adults: 1–2 tablets every 4 hours as needed. Do not exceed 12 tablets in 24 hours unless directed by a doctor.",
    description: "Bayer Aspirin provides effective relief for pain, inflammation, and fever. Trusted for decades as a reliable household remedy.",
    manufacturer: "Bayer HealthCare",
    expiry_date: "2026-08-31",
    category: "otc"
  },

  {
    id: "prod_cetirizine_10",
    title: "Cetirizine 10mg Tablets",
    brand: "AllerCare",
    short: "Once-daily antihistamine for allergy relief.",
    rating: { avg: 4.4, count: 86 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/6865181/pexels-photo-6865181.jpeg?cs=srgb&dl=pexels-cottonbro-6865181.jpg&fm=jpg",
      "https://images.pexels.com/photos/3873191/pexels-photo-3873191.jpeg?cs=srgb&dl=pexels-polina-tankilevitch-3873191.jpg&fm=jpg"
    ],
    variants: [
      { id: "v10", label: "10 tablets", price: 3.49, mrp: 4.99, stock: 120 },
      { id: "v30", label: "30 tablets", price: 8.49, mrp: 11.99, stock: 56 }
    ],
    active_ingredients: [
      { name: "Cetirizine", amount: 10, unit: "mg" }
    ],
    directions: "Adults and children over 12: 1 tablet (10 mg) once daily.",
    description: "Effective relief from allergic rhinitis and urticaria symptoms.",
    manufacturer: "AllerCare Labs",
    expiry_date: "2026-11-15",
    categories: ["otc"]
  },

  {
    id: "prod_paracetamol_syrup",
    title: "Paracetamol Syrup 120mg/5ml (100ml)",
    brand: "ChildRelief",
    short: "Liquid paracetamol for children — fever & pain relief.",
    rating: { avg: 4.7, count: 210 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/5858861/pexels-photo-5858861.jpeg?cs=srgb&dl=pexels-cottonbro-5858861.jpg&fm=jpg",
      "https://images.pexels.com/photos/5858858/pexels-photo-5858858.jpeg?cs=srgb&dl=pexels-cottonbro-5858858.jpg&fm=jpg"
    ],
    variants: [
      { id: "b100", label: "100 ml", price: 4.25, mrp: 5.99, stock: 48 }
    ],
    active_ingredients: [
      { name: "Paracetamol", amount: 120, unit: "mg/5ml" }
    ],
    directions: "Dose by weight/age. Read label. Do not exceed recommended dose.",
    description: "Sugar-free paracetamol syrup for safe pediatric dosing.",
    manufacturer: "ChildRelief Pharmaceuticals",
    expiry_date: "2025-12-01",
    categories: ["otc"]
  },

  {
    id: "prod_multivitamin_mini",
    title: "Daily Multivitamin Tablets (30)",
    brand: "NutriPlus",
    short: "Complete daily multivitamin for general wellness.",
    rating: { avg: 4.3, count: 64 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg?cs=srgb&dl=pexels-shvetsa-3683074.jpg&fm=jpg",
      "https://images.pexels.com/photos/3683101/pexels-photo-3683101.jpeg?cs=srgb&dl=pexels-shvetsa-3683101.jpg&fm=jpg"
    ],
    variants: [
      { id: "pack30", label: "30 tablets", price: 9.5, mrp: 12.99, stock: 78 }
    ],
    active_ingredients: [
      { name: "Vitamin C", amount: 60, unit: "mg" },
      { name: "Vitamin D", amount: 400, unit: "IU" },
      { name: "B12", amount: 2.5, unit: "mcg" }
    ],
    directions: "Take one tablet daily with food.",
    description: "Daily multivitamin to support energy and immune health.",
    manufacturer: "NutriPlus",
    expiry_date: "2027-03-20",
    categories: ["otc"]
  },

  // --- Ortho (1 product) ---
  {
    id: "prod_knee_brace_stab",
    title: "Adjustable Stabilizing Knee Brace (Universal)",
    brand: "SupportCo",
    short: "Breathable knee brace with stabilizing side stays.",
    rating: { avg: 4.5, count: 48 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/32546043/pexels-photo-32546043.jpeg?cs=srgb&dl=pexels-cristian-camilo-estrada-2152272341-32546043.jpg&fm=jpg",
      "https://images.pexels.com/photos/29558666/pexels-photo-29558666.jpeg?cs=srgb&dl=pexels-anhleephoto-29558666.jpg&fm=jpg"
    ],
    variants: [
      { id: "size_m", label: "Medium", price: 29.95, mrp: 39.95, stock: 25 },
      { id: "size_l", label: "Large", price: 29.95, mrp: 39.95, stock: 18 }
    ],
    active_ingredients: [],
    directions: "Measure knee circumference and choose correct size. Wear during activity as needed.",
    description: "Comfortable neoprene brace to support mild to moderate knee instability.",
    manufacturer: "SupportCo Medical",
    expiry_date: "2030-01-01",
    categories: ["ortho"]
  },

  // --- Wound Care (1 product) ---
  {
    id: "prod_hydrocolloid_10",
    title: "Hydrocolloid Dressings (Pack of 10)",
    brand: "HealFast",
    short: "Low-profile hydrocolloid for moist wound healing.",
    rating: { avg: 4.6, count: 39 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/6193375/pexels-photo-6193375.jpeg?cs=srgb&dl=pexels-thirdman-6193375.jpg&fm=jpg",
      "https://images.pexels.com/photos/7722840/pexels-photo-7722840.jpeg?cs=srgb&dl=pexels-tara-winstead-7722840.jpg&fm=jpg"
    ],
    variants: [
      { id: "pack10", label: "10 dressings", price: 18.5, mrp: 24.99, stock: 32 }
    ],
    active_ingredients: [],
    directions: "Clean wound, apply dressing, change if edges lift or per protocol.",
    description: "Promotes moist wound healing for low to moderate exuding wounds.",
    manufacturer: "HealFast",
    expiry_date: "2028-06-30",
    categories: ["wound"]
  },

  // --- Mobility (1 product) ---
  {
    id: "prod_aluminium_walker",
    title: "Folding Aluminium Walker (Adjustable Height)",
    brand: "MoveEase",
    short: "Lightweight walker for stable indoor/outdoor use.",
    rating: { avg: 4.2, count: 22 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/6647036/pexels-photo-6647036.jpeg?cs=srgb&dl=pexels-rdne-6647036.jpg&fm=jpg",
      "https://images.pexels.com/photos/33061506/pexels-photo-33061506.jpeg?cs=srgb&dl=pexels-wheeleo-33061506.jpg&fm=jpg"
    ],
    variants: [
      { id: "std", label: "Standard", price: 79.99, mrp: 99.99, stock: 10 }
    ],
    active_ingredients: [],
    directions: "Adjust height before first use. Ensure locks are engaged.",
    description: "Foldable walker with rubber tips and adjustable height for daily mobility support.",
    manufacturer: "MoveEase",
    expiry_date: "2030-05-01",
    categories: ["mobility"]
  },

  // --- Diagnostics (1 product) ---
  {
    id: "prod_glucose_monitor_kit",
    title: "Glucose Monitoring Kit (Meter + 25 strips)",
    brand: "GlucoPro",
    short: "Compact meter with backlit display and memory.",
    rating: { avg: 4.5, count: 110 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/7653134/pexels-photo-7653134.jpeg?cs=srgb&dl=pexels-pavel-danilyuk-7653134.jpg&fm=jpg",
      "https://images.pexels.com/photos/5469165/pexels-photo-5469165.jpeg?cs=srgb&dl=pexels-polina-tankilevitch-5469165.jpg&fm=jpg"
    ],
    variants: [
      { id: "kit", label: "Meter + 25 strips", price: 39.0, mrp: 49.99, stock: 40 }
    ],
    active_ingredients: [],
    directions: "Follow meter instructions. Use test strips compatible with the meter.",
    description: "Accurate glucose readings with simple one-button operation.",
    manufacturer: "GlucoPro",
    expiry_date: "2027-09-10",
    categories: ["diagnostics"]
  },

  // --- Respiratory (1 product) ---
  {
    id: "prod_nebulizer_home",
    title: "Portable Compressor Nebulizer",
    brand: "BreatheSafe",
    short: "Compact nebulizer for inhalation therapy at home.",
    rating: { avg: 4.1, count: 31 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/5858856/pexels-photo-5858856.jpeg?cs=srgb&dl=pexels-cottonbro-5858856.jpg&fm=jpg"
    ],
    variants: [
      { id: "unit", label: "Unit", price: 49.99, mrp: 64.99, stock: 14 }
    ],
    active_ingredients: [],
    directions: "Use with prescribed medication. Clean after each use.",
    description: "Quiet compressor nebulizer suitable for adults and children.",
    manufacturer: "BreatheSafe",
    expiry_date: "2029-02-14",
    categories: ["respiratory"]
  },

  // --- Incontinence (1 product) ---
  {
    id: "prod_adult_briefs_medium",
    title: "Adult Briefs (Medium, 10pcs)",
    brand: "ComfortCare",
    short: "Absorbent briefs with breathable material.",
    rating: { avg: 4.0, count: 18 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/1729931/pexels-photo-1729931.jpeg?cs=srgb&dl=pexels-nashua-volquez-young-452210-1729931.jpg&fm=jpg",
      "https://images.pexels.com/photos/1786244/pexels-photo-1786244.jpeg?cs=srgb&dl=pexels-italo-melo-881954-1786244.jpg&fm=jpg"
    ],
    variants: [
      { id: "m10", label: "Medium (10 pcs)", price: 12.5, mrp: 16.99, stock: 60 }
    ],
    active_ingredients: [],
    directions: "Change as needed based on saturation.",
    description: "High-absorbency adult briefs with adjustable tabs for secure fit.",
    manufacturer: "ComfortCare",
    expiry_date: "2030-08-01",
    categories: ["incontinence"]
  },

  // --- Personal Care (1 product) ---
  {
    id: "prod_hand_sanitizer_500",
    title: "Hand Sanitizer Gel 70% (500ml)",
    brand: "SafeHands",
    short: "Fast-acting 70% alcohol hand sanitizer gel.",
    rating: { avg: 4.8, count: 95 },
    requires_prescription: false,
    images: [
      "https://images.pexels.com/photos/3962328/pexels-photo-3962328.jpeg?cs=srgb&dl=pexels-shvetsa-3962328.jpg&fm=jpg",
      "https://images.pexels.com/photos/3962331/pexels-photo-3962331.jpeg?cs=srgb&dl=pexels-shvetsa-3962331.jpg&fm=jpg"
    ],
    variants: [
      { id: "500ml", label: "500 ml", price: 7.99, mrp: 9.99, stock: 150 }
    ],
    active_ingredients: [
      { name: "Ethyl alcohol", amount: 70, unit: "%" }
    ],
    directions: "Apply to hands and rub until dry. Keep away from heat and flame.",
    description: "Effective germ-killing gel for hygiene on the go.",
    manufacturer: "SafeHands Ltd.",
    expiry_date: "2026-07-30",
    categories: ["personal"]
  }
];

export default PRODUCTS;
